/**
 * Central drill-through URL builders for Visual Analytics.
 * Re-exports utils/drillthrough and adds toAnalyticsUrl.
 */

import {
  toActivitiesUrl as baseToActivitiesUrl,
  toExplorerUrl,
  type ActivitiesDrillFilters,
} from '@/utils/drillthrough';

export type { ActivitiesDrillFilters };

const ANALYTICS_BASE = '/app/analytics';

/** Re-export: build Activities URL with query params (includes float_min, float_max). */
export const toActivitiesUrl = baseToActivitiesUrl;

/**
 * Build Analytics sub-page URL by tab key.
 */
export function toAnalyticsUrl(tab: 'overview' | 'health' | 'critical-path' | 'milestones' | 'quality' | 'charts'): string {
  // Normalize legacy 'charts' to 'overview'
  const resolved = tab === 'charts' ? 'overview' : tab;
  return `${ANALYTICS_BASE}/${resolved}`;
}

export { toExplorerUrl };
